import { render } from "./Baseinfo.vue?vue&type=template&id=1ac66c4e&scoped=true"
import script from "./Baseinfo.vue?vue&type=script&lang=js"
export * from "./Baseinfo.vue?vue&type=script&lang=js"

import "./Baseinfo.vue?vue&type=style&index=0&id=1ac66c4e&lang=less&scoped=true"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac66c4e"]])

export default __exports__